module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.2ab297df.svg";